import 'babel-polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import Router from './router'
import Services from './services'

Vue.config.productionTip = false

Router.beforeEach((to, from, next) => {
  let token = to.query.token;
  if (token != null && window.$cookies.get('token') == null) {
    // Validate token
    Services.getToken(token).then(res => {
      if (res.result) {
        window.$cookies.set('token', token)
        setTimeout(() => app.loading = true, 0)
        next()
      } else {
        window.$cookies.set('token', null)
        window.location = 'http://www.federlegnoarredo.it/it/federazione/associarsi/come-associarsi?err=1'
      }
    }).catch(() => {
      window.$cookies.set('token', null)
      window.location = 'http://www.federlegnoarredo.it/it/federazione/associarsi/come-associarsi?err=2'
    })
  } else {
    if (window.$cookies.get('token') != null) {
      setTimeout(() => app.loading = true, 0)
      next()
    } else {
      window.$cookies.set('token', null)
      window.location = 'http://www.federlegnoarredo.it/it/federazione/associarsi/come-associarsi?err=3'
    }
  }
})


Router.afterEach(() => {
  setTimeout(() => app.loading = false, 500) // timeout for demo purposes
})

const app = new Vue({
  data: { loading: true },
  router: Router,
  render: h => h(App),
}).$mount('#app')

